<template>
  <v-container class="py-4 ma-0 d-flex flex-column gap-1 dashboard-wrapper">
    <!-- title and subtitle -->
    <v-container class="pa-0 pr-10 ma-0 d-flex flex-column gap-3 text-right rtl">
      <v-card-text class="pa-0 ma-0 text-body-1 white--text">
        {{ $t("businessIntelligenceDashboard") }}
      </v-card-text>
      <v-card-text class="pa-0 ma-0 text-body-2" style="color: #dbeafe">
        {{ $t("business_overview_performance") }}
      </v-card-text>
    </v-container>
    <!-- info card -->
    <v-row class="ma-0 pa-0">
      <v-col
        v-for="(item, index) in stats"
        :key="index"
        cols="12"
        sm="12"
        md="6"
        lg="3"
        class="ma-0"
      >
        <v-card class="stat-card ma-0 pa-3 d-flex flex-column gap-2">
          <!-- title + icon -->
          <v-container class="pa-0 ma-0 d-flex justify-space-between align-center">
            <v-card-text class="pa-0 ma-0 text-body-1" style="color: #dbeafe">
              {{ item.title }}
            </v-card-text>
            <my-icon
              :name="getIconName(item.title).name"
              :width="18"
              :height="18"
              :stroke="getIconName(item.title).color"
            />
          </v-container>
          <!-- value -->
          <v-container class="pa-0 ma-0 d-flex justify-end">
            <v-card-text class="pa-0 ma-0 text-body-1 white--text">
              {{ item.value }}
            </v-card-text>
          </v-container>
          <!-- percent -->
          <v-container class="pa-0 ma-0 d-flex align-center">
            <v-icon size="18" :color="getPercentColor(item.trend)" class="ml-1">
              {{ getPercentIcon(item.trend) }}
            </v-icon>

            <v-card-text
              class="pa-0 ma-0 text-body-1"
              :style="{ color: getPercentColor(item.trend) }"
            >
              {{ item.percent }}٪ {{ item.compare }}
            </v-card-text>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import MyIcon from "@/views/dashboard/components/general/icon/MyIcon.vue";
export default {
  name: "DashboardStats",
  components: {
    MyIcon,
  },
  props: {
    profitData: {
      type: [Number, String, Object],
      required: true,
    },
    sellData: {
      type: [Number, String, Object],
      required: true,
    },
    warehouseData: {
      type: [Array, Object],
      required: true,
    },
    crmData: {
      type: [Array, Object],
      required: true,
    },
  },
  data() {
    return {
      stats: [
        {
          title: this.$t("today_total_sales"),
          value: this.formatNumber(this.sellData?.current ?? 0),
          percent: this.sellData?.diffPercent ?? 0,
          trend: this.sellData?.trend ?? "none",
          compare: this.$t("month_compare"),
        },
        {
          title: this.$t("net_profit"),
          value: this.formatNumber(this.profitData?.current ?? 0),
          percent: this.profitData?.diffPercent ?? 0,
          trend: this.profitData?.trend ?? "none",
          compare: this.$t("month_compare"),
        },
        {
          title: this.$t("entrepotStock"),
          value: this.formatNumber(this.warehouseData?.current?.total_balance_count ?? 0),
          percent: this.warehouseData?.diffPercent?.total_balance_count ?? 0,
          trend: this.warehouseData?.trend?.total_balance_count ?? "none",
          compare: this.$t("month_compare"),
        },
        {
          title: this.$t("total_customers"),
          value: this.crmData?.current ?? 0,
          percent: this.crmData?.diffPercent ?? 0,
          trend: this.crmData?.trend ?? "none",
          compare: this.$t("month_compare"),
        },
      ],
    };
  },
  methods: {
    getIconName(title) {
      if (title === this.$t("today_total_sales"))
        return {
          name: "arrow-up",
          color: "#7BF1A8",
        };
      if (title === this.$t("net_profit"))
        return {
          name: "currency-icon",
          color: "#7BF1A8",
        };
      if (title === this.$t("total_customers"))
        return {
          name: "users-icon",
          color: "#FDA5D5",
        };
      if (title === this.$t("entrepotStock"))
        return {
          name: "cube-icon",
          color: "#FFB86A",
        };
    },
    formatNumber(value) {
      if (value === null || value === undefined) return "-";
      return this.$numberFormat(value);
    },
    getPercentColor(trend) {
      if (trend != null && trend == "increase") {
        return "#7BF1A8";
      }
      if (trend != null && trend == "decrease") {
        return "#FFA2A2";
      }
      if (trend != null && trend == "none") {
        return "#a7a4a4ff";
      }
    },
    getPercentIcon(trend) {
      if (trend != null && trend == "increase") {
        return "mdi-arrow-top-right";
      }
      if (trend != null && trend == "decrease") {
        return "mdi-arrow-bottom-right";
      }
      if (trend != null && trend == "none") {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.dashboard-wrapper {
  border-radius: 4px;
  border: solid #000 1px;
  background: linear-gradient(135deg, #155dfc, #1447e6, #6e11b0);
}
.stat-card {
  border-radius: 4px !important;
  border: 1px solid #ffffff33;
  background: rgba(255, 255, 255, 0.12) !important;
  backdrop-filter: blur(5px);
}
</style>
